import type { ReactNode } from 'react';
import DevicesIcon from '@mui/icons-material/Devices';
import type { SvgIconProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type PlatformIconsProps = {
  leadIconProps: SvgIconProps;
  children?: ReactNode;
};

const Container = styled('div')({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  flexWrap: 'wrap',
});

/**
 * PlatformIcons component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {PlatformIconsProps} platformIconsProps - The props for the PlatformIcons component
 * @returns {ReactElement} The PlatformIcons component
 */

export const PlatformIcons = ({
  leadIconProps,
  children,
}: PlatformIconsProps) => {
  return (
    <>
      <Container>
        <DevicesIcon fontSize="small" color="primary" {...leadIconProps} />
        {children}
      </Container>
    </>
  );
};
